module.exports = __webpack_public_path__ + "img/selected4-min.39f49f95.png";